export const ChartDataSource = {
	GRAPHITE: "chart-source-graphite",
	URL: "chart-source-url"
}